import React, {Fragment} from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    CardActions,
    Filter,
    SearchInput,
    SelectField,
    EditButton
 } from 'react-admin';
 import EditIcon from '../../icon/IcnEdit';
 import UnselectAllButton from '../common/UnselectAllButton';
 import UserBulkDeleteButton from './UserBulkDeleteButton';
 
 const UserFilter = (props) => (
    <Filter {...props}>
         <SearchInput source="q" alwaysOn label='resources.users.fields.search'/>
    </Filter>
);

const UserActions = ({
    bulkActions,
    basePath,
    displayedFilters,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter
}) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
{/* デフォルトのExportボタンを無効化
         <ExportButton
            resource={resource}
            sort={currentSort}
            filter={filterValues}
            exporter={exporter}
        />
*/} 
{/* Add your custom actions 
        <Button primary onClick={customAction}>Custom Action</Button>
*/}
    </CardActions>
);

const UserBulkActionButtons = props => (
    <Fragment>
        <UnselectAllButton {...props} />
        <UserBulkDeleteButton  {...props} />
    </Fragment>
);

const UserList = props => (
    <List {...props} bulkActionButtons={<UserBulkActionButtons />} actions={<UserActions />} filters={<UserFilter />}>
        <Datagrid>
            <TextField source="name" />
            <TextField source="email" />
            <SelectField source="permission" choices={[
                        { id: 0, name: 'resources.users.enums.permission.normal' },
                        { id: 1, name: 'resources.users.enums.permission.operationManager' },
                        { id: 2, name: 'resources.users.enums.permission.accountManager'},
                        { id: 3, name: 'resources.users.enums.permission.admin'}
                    ]} />
            <EditButton icon={<EditIcon />}/>
        </Datagrid>
    </List>
);

export default UserList;